export const DOSSIER_DETAILS_QUERY_KEY = "details";
export const NAZORG_QUERY_KEY = "nazorg";
